module.exports = __webpack_public_path__ + "static/media/cash-vouchar.8b16d09f.png";